/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { Type } from '@sinclair/typebox';
import { defaultPluginSchema } from '../default-context-schema.js';
import { AmlSchema } from './aml-schema.js';

var IndividualSanctionsPluginSchema = Type.Optional(Type.Composite([defaultPluginSchema, Type.Object({
  data: AmlSchema
})]));

export { IndividualSanctionsPluginSchema };
//# sourceMappingURL=individual-sanctions-plugin-schema.js.map
